// index.tsx — T099
// Route racine "/" : détermine le tableau de bord d'atterrissage selon le rôle
// et les permissions de l'utilisateur (au lieu d'un redirect fixe vers
// /dashboard, inaccessible aux rôles à portée Région/Site).

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuth } from "@/application/contexts/AuthContext";
import { usePermissions } from "@/application/hooks/usePermissions";
import { LoadingSpinner } from "@/shared/components/LoadingSpinner";

export const Route = createFileRoute("/")({
  component: function IndexComponent() {
    const { currentUser, isLoading } = useAuth();
    const permissions = usePermissions();
    const navigate = useNavigate();

    useEffect(() => {
      if (isLoading || !currentUser) return;

      // Rôles à portée nationale (SystemAdmin, ResponsableHse, HsedgSpecialist,
      // LaborRelation, HrService, ManagingDirector)
      if (permissions.duerp.canViewNationalDashboard()) {
        void navigate({ to: "/dashboard" });
        return;
      }

      // Rôle à portée région (SeniorManager) : atterrissage sur sa région
      const regionPermission = currentUser.permissions.find(
        (permission) => permission.scopeLevel === "Region" && permission.regionId,
      );
      if (regionPermission?.regionId) {
        void navigate({
          to: "/dashboard/regions/$regionId",
          params: { regionId: regionPermission.regionId },
        });
        return;
      }

      // Rôles à portée site (Délégué du personnel, Responsable de station) :
      // atterrissage sur la liste des sites accessibles.
      void navigate({ to: "/sites" });
    }, [isLoading, currentUser, permissions, navigate]);

    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner size="lg" label="Redirection…" />
      </div>
    );
  },
});
